import { ArrowLeft, Play, Timer, CheckCircle2, Circle, Square, Triangle, Diamond, Check, X } from 'lucide-react';

const LUCIDE_BY_NAME = {
  circle: Circle,
  square: Square,
  triangle: Triangle,
  diamond: Diamond,
  check: Check,
  x: X,
};

const ANSWER_COLORS = [
  { bg: 'bg-mp-darkgreen', text: 'text-white',         lucideName: 'circle' },
  { bg: 'bg-mp-fox-rust',  text: 'text-white',         lucideName: 'square' },
  { bg: 'bg-mp-lime',      text: 'text-mp-darkgreen',  lucideName: 'triangle' },
  { bg: 'bg-mp-teal',      text: 'text-white',         lucideName: 'diamond' },
];

export default function QuizPreview({ quiz, onStartSession, onBack }) {
  return (
    <div className="min-h-screen bg-mp-bg-lightgreen font-body">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[rgba(17,73,66,0.12)] px-4 py-3">
        <div className="max-w-3xl mx-auto flex justify-between items-center gap-3">
          <button
            onClick={onBack}
            className="inline-flex items-center gap-1.5 text-mp-darkgreen hover:text-mp-magenta transition-colors font-display font-bold text-sm"
          >
            <ArrowLeft size={18} />
            Tilbake til redigering
          </button>
          <div className="flex items-center gap-3">
            <h1 className="font-display text-lg text-mp-darkgreen hidden sm:block">{quiz.title}</h1>
            <button onClick={onStartSession} className="mp-cta !py-2.5 !text-sm">
              <Play size={16} />
              Start kviss
            </button>
          </div>
        </div>
      </header>

      {/* Quiz Info */}
      <div className="max-w-3xl mx-auto px-4 pt-6 pb-2">
        <span className="mp-eyebrow">Førehandsvising</span>
        <h2 className="font-display text-2xl text-mp-darkgreen mt-1">{quiz.title}</h2>
        <p className="font-body text-mp-stone-700 text-sm mt-1">
          {quiz.questions.length} spørsmål
        </p>
      </div>

      {/* All Questions */}
      <div className="max-w-3xl mx-auto px-4 py-4 space-y-5 pb-24">
        {quiz.questions.map((question, qIndex) => (
          <div
            key={question.id || qIndex}
            className="bg-white rounded-[20px] border border-[rgba(17,73,66,0.12)] shadow-mp-1 overflow-hidden"
          >
            {/* Question Header */}
            <div className="bg-mp-bg-lightgreen px-5 py-3 border-b border-[rgba(17,73,66,0.10)] flex items-center justify-between">
              <span className="font-display text-[11px] uppercase tracking-[0.18em] text-mp-teal">
                Spørsmål {qIndex + 1} av {quiz.questions.length}
              </span>
              <span className="font-display text-mp-stone-500 text-xs flex items-center gap-1.5">
                <Timer size={14} />
                {question.timeLimit || 20}s
              </span>
            </div>

            {/* Question Image */}
            {question.imageUrl && (
              <div className="w-full aspect-video bg-mp-bg-lightgreen overflow-hidden">
                <img src={question.imageUrl} alt="" className="w-full h-full object-cover" />
              </div>
            )}

            {/* Question Text */}
            <div className="px-5 py-4 border-l-[6px] border-mp-darkgreen">
              <h3 className="font-display text-lg text-mp-darkgreen leading-snug">
                {question.text}
              </h3>
            </div>

            {/* Answer Grid */}
            <div className="grid grid-cols-2 gap-2.5 px-5 pb-5">
              {question.answers.map((answer, aIndex) => {
                const colorConfig = ANSWER_COLORS[aIndex] || ANSWER_COLORS[0];
                const LucideIcon = LUCIDE_BY_NAME[colorConfig.lucideName] || Circle;
                return (
                  <div
                    key={answer.id || aIndex}
                    className={`flex items-center gap-3 p-3 rounded-xl border-2 transition-all ${
                      answer.isCorrect
                        ? 'bg-mp-bg-lightgreen border-mp-magenta'
                        : 'bg-white border-[rgba(17,73,66,0.10)]'
                    }`}
                  >
                    <div className={`w-8 h-8 ${colorConfig.bg} ${colorConfig.text} rounded-lg flex items-center justify-center shrink-0`}>
                      <LucideIcon size={16} strokeWidth={2.5} />
                    </div>
                    <span className="font-display text-sm text-mp-darkgreen">
                      {answer.text}
                    </span>
                    {answer.isCorrect && (
                      <CheckCircle2 size={20} className="text-mp-magenta ml-auto shrink-0" />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
